import currencyFormatter from "currency-formatter";
import { store } from "../source/index";
export const toFormatPrice = (amount, args = {}, customcurrency) => {
    if (amount === null || amount === undefined || amount === "" || amount === 0) {
        return 0.00;
    }
    var state = store.getState();
    var OrgSettings = state?.app?.organisation_settings;
    var price_format_options = OrgSettings?.price_format;
    var currency = customcurrency ? customcurrency : price_format_options?.currency || "USD";
    var thousand_separator = price_format_options?.thousand_separator || ",";
    var decimal_point = price_format_options?.decimal_point || 2;
    if (thousand_separator === ".") {
        amount = currencyFormatter.unformat(amount, { locale: 'nl-NL' });
        amount = parseFloat(amount.toFixed(decimal_point));
    } else if (thousand_separator === ",") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-US' });
        amount = parseFloat(amount.toFixed(decimal_point));
    } else if (currency === "INR") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-IN' });
        amount = parseFloat(amount.toFixed(decimal_point));
    }
    if (args.addSymbol) {
        return Intl.NumberFormat(thousand_separator === "." ? 'nl-NL' : 'en-US', {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: decimal_point,
            maximumFractionDigits: decimal_point
        }).format(amount);
    } else {
        return Intl.NumberFormat(thousand_separator === "." ? 'nl-NL' : 'en-US',{
            minimumFractionDigits: decimal_point,
            maximumFractionDigits: decimal_point
        }).format(amount);
    }


}

export const toUnformatPrice = (amount, args = {}) => {
    var state = store.getState();
    var OrgSettings = state?.app?.organisation_settings;
    var price_format_options = OrgSettings?.price_format;
    var currency = price_format_options?.currency || "USD";
    // var show_amount_in = price_format_options?.show_amount_in || "Million";
    var thousand_separator = price_format_options?.thousand_separator || ",";
    var decimal_point = price_format_options?.decimal_point || 2;
    if (thousand_separator === ".") {
        amount = currencyFormatter.unformat(amount, { locale: 'nl-NL' });
        amount = parseFloat(amount.toFixed(decimal_point));
    } else if (thousand_separator === ",") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-US' });
        amount = parseFloat(amount.toFixed(decimal_point));

    } else if (currency === "INR") {
        amount = currencyFormatter.unformat(amount, { locale: 'en-IN' });
        amount = parseFloat(amount.toFixed(decimal_point));
    }

    return amount;
}

export const numberFormatter = (amount) => {
    if (amount === null || amount === undefined) {
        return 0; // Return 0 if the amount is invalid
    }
    var state = store.getState();
    var OrgSettings = state?.app?.organisation_settings;
    var price_format_options = OrgSettings?.price_format;
    const decimal_point = Number(price_format_options?.decimal_point) || 2;
    const num = Number(amount);
    if (!Number.isFinite(num)) {
        return 0;
    }

    const factor = Math.pow(10, decimal_point);
    // num * factor can land just under the intended value (e.g. 2.03 * 100 === 202.99999999999997),
    // which Math.trunc would then chop down to the wrong number. Rounding off that float noise first
    // (well within decimal_point precision) keeps this a truncation, not a round, of the real value.
    const scaled = Number((num * factor).toFixed(6));
    const truncated = Math.trunc(scaled) / factor;
    return truncated.toFixed(decimal_point);
};

